import Vue from 'vue'

/** 权限指令**/
const has = Vue.directive('has', {
  bind: function(el, binding, vnode) {
    console.log(vnode.context.$store.getters.getOperatorRole, binding.value, binding.value.indexOf(vnode.context.$store.getters.getOperatorRole))
    if (binding.value.indexOf(vnode.context.$store.getters.getOperatorRole) === -1) {
      el.parentNode.removeChild(el);
    }
  }
});

export { has }



// WEBPACK FOOTER //
// ./src/directive/checkBtnRole.js